import { useState } from "react";
import { convertUTCtoMSK } from "../../../../../../../utils"
import { IRequisiteType } from "../../core/response.types";
import { toggleEnableRequisiteType } from "../../core/api";
import { KTIcon } from "../../../../../../../_metronic/helpers";

interface Props {
  requisiteType: IRequisiteType
  onEdit: (item: IRequisiteType) => void
  onToggleSuccess: (id: number, enabled: boolean) => void
}

export default ({ requisiteType, onToggleSuccess, onEdit }: Props) => {
    const [loading, setLoading] = useState(false);

    const handleToggle = async () => {
        if (loading) return

        setLoading(true);

        try {
            const response = await toggleEnableRequisiteType(requisiteType.id);
            if (!response?.data?.success) {
                throw new Error(
                    'errors' in response?.data ? response?.data?.errors?.general_error : 'Unknown error'
                )
            }
            onToggleSuccess(requisiteType.id, response.data.data.enabled);
        } catch (error) {
            console.error('Ошибка переключения статуса типа реквизита:', error)
        } finally {
            setLoading(false);
        }
    }   

    return (<>
        <tr>
            <td>{requisiteType.id}</td>
            <td>{requisiteType.name}</td>
            <td>{requisiteType.code}</td>     
            <td>{requisiteType.paymentMethods ? requisiteType.paymentMethods.map((pm) => (
                <span key={pm} className='badge'>{pm}</span>
            )) : ''}</td>      
            <td>{convertUTCtoMSK(requisiteType.createdAt)}</td>
            <td>
                <button
                    type="button"
                    className={`btn btn-sm ${requisiteType.enabled ? 'btn-light-success' : 'btn-light-danger'} min-w-90px px-2 py-1`}
                    disabled={loading}
                    onClick={handleToggle}
                >
                    {loading ? (
                        <span className="spinner-border spinner-border-sm" />
                    ) : 
                        requisiteType.enabled ? 'Enabled' : 'Disabled'
                    }
                </button>    
            </td>   
            <td>
                <button
                    type="button"
                    className={`btn btn-sm btn-icon btn-bg-light btn-active-color-primary px-2`}
                    disabled={loading}
                    onClick={() => {onEdit(requisiteType)}}
                >
                    {loading ? 
                        <span className="spinner-border spinner-border-sm" />
                    : 
                        <KTIcon iconName='pencil' className='fs-3' />
                    }
                </button>
            </td>
        </tr>
    </>)
}